import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["selected"]
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = ["selected"]
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = ["selected"]
const _hoisted_12 = ["selected"]
const _hoisted_13 = ["selected"]
const _hoisted_14 = ["selected"]
const _hoisted_15 = ["selected"]
const _hoisted_16 = ["selected"]
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = {
  type: "button",
  class: "btn btn-primary"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_20 = { class: "card-body pt-0" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "symbol symbol-45px me-5" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle fa-fw" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen fa-fw" }, null, -1)
const _hoisted_28 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_29 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_30 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-auto py-4",
  "data-kt-menu": "true"
}
const _hoisted_31 = { class: "menu-item px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            class: "form-control form-control-solid w-250px ps-15",
            placeholder: _ctx.I18nUtils.translate('sea.pages.products.searchHint')
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.name],
            [_directive_debounce, _ctx.getData, "500ms"]
          ]),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBranchChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.branchId === 0
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.selectTextBranchAll")), 9, _hoisted_7),
            (_ctx.branchesRef && _ctx.branchesRef.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.branchesRef, (branch) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: branch.id,
                    value: branch.id,
                    selected: _ctx.branchId === branch.id
                  }, _toDisplayString(branch.name), 9, _hoisted_8))
                }), 128))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onProductCategoryChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.productCategoryId === 0
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.selectTextCategoryAll")), 9, _hoisted_9),
            (_ctx.productCategoriesRef && _ctx.productCategoriesRef.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.productCategoriesRef, (productCategory) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: productCategory.id,
                    value: productCategory.id,
                    selected: _ctx.productCategoryId === productCategory.id
                  }, _toDisplayString(productCategory.name), 9, _hoisted_10))
                }), 128))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch Open Status",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onIsDeliveryChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.isDelivery === null
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.products.selectTextIsDeliveryAll"
                )), 9, _hoisted_11),
            _createElementVNode("option", {
              value: "true",
              selected: _ctx.isDelivery === true
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.products.selectTextIsDeliveryDelivery"
                )), 9, _hoisted_12),
            _createElementVNode("option", {
              value: "false",
              selected: _ctx.isDelivery === false
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.products.selectTextIsDeliveryPickupOnly"
                )), 9, _hoisted_13)
          ], 32),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch Open Status",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onIsEnabledChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.isEnabled === null
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.selectTextIsEnabledAll")), 9, _hoisted_14),
            _createElementVNode("option", {
              value: "true",
              selected: _ctx.isEnabled === true
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.products.selectTextIsEnabledEnabled"
                )), 9, _hoisted_15),
            _createElementVNode("option", {
              value: "false",
              selected: _ctx.isEnabled === false
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.products.selectTextIsEnabledDisabled"
                )), 9, _hoisted_16)
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", _hoisted_18, [
          _createElementVNode("span", null, [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.buttonAddProduct")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Datatable, {
        loading: _ctx.loading,
        "table-headers": _ctx.tableHeaders,
        data: _ctx.productsRef,
        total: _ctx.productsTotalRef,
        "page-number": _ctx.productsPageNumberRef,
        "page-size": _ctx.productsPageSizeRef,
        onPageSizeChange: _ctx.updatePageSize,
        onPageNumberChange: _ctx.updatePageNumber,
        onSort: _ctx.sortProducts
      }, {
        "cell-id": _withCtx(({ row: product }) => [
          _createElementVNode("strong", null, _toDisplayString(product.id), 1)
        ]),
        "cell-name": _withCtx(({ row: product }) => [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (product.productImages && product.productImages.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "symbol-label",
                    style: _normalizeStyle({
                  backgroundImage: `url(${product.productImages[0].secureUrl})`,
                })
                  }, null, 4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("strong", null, _toDisplayString(product.name), 1)
          ])
        ]),
        "cell-category": _withCtx(({ row: product }) => [
          (product.productCategory)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_23, _toDisplayString(product.productCategory.name), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-price": _withCtx(({ row: product }) => [
          _createElementVNode("strong", null, "$" + _toDisplayString(parseFloat(product.price).toFixed(2)), 1)
        ]),
        "cell-branch": _withCtx(({ row: product }) => [
          (product.branch)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_24, _toDisplayString(product.branch.name), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-delivery": _withCtx(({ row: product }) => [
          _createElementVNode("span", {
            class: _normalizeClass([`badge-light-${product.isDelivery ? 'success' : 'primary'}`, "badge"])
          }, _toDisplayString(product.isDelivery
                ? _ctx.I18nUtils.translate("sea.pages.products.badgeTextDelivery")
                : _ctx.I18nUtils.translate("sea.pages.products.badgeTextPickupOnly")), 3)
        ]),
        "cell-enabled": _withCtx(({ row: product }) => [
          _createElementVNode("span", {
            class: _normalizeClass([`badge-light-${product.isEnabled ? 'success' : 'danger'}`, "badge"])
          }, _toDisplayString(product.isEnabled
                ? _ctx.I18nUtils.translate("sea.pages.products.badgeTextEnabled")
                : _ctx.I18nUtils.translate("sea.pages.products.badgeTextDisabled")), 3)
        ]),
        "cell-date": _withCtx(({ row: product }) => [
          _hoisted_25,
          _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(product.createdAt)) + " ", 1),
          (product.modifiedAt)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_26,
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(product.modifiedAt)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        "cell-actions": _withCtx(({ row: product }) => [
          _createElementVNode("a", _hoisted_28, [
            _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.buttonActions")) + " ", 1),
            _createElementVNode("span", _hoisted_29, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_router_link, {
                to: {
                  name: 'product',
                  params: { id: product.id },
                },
                class: "menu-link px-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.products.buttonView")), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading", "table-headers", "data", "total", "page-number", "page-size", "onPageSizeChange", "onPageNumberChange", "onSort"])
    ])
  ]))
}